import {Component} from "@angular/core";
import {AgentsSettingsComponent} from "./agents-settings.component";
import {DesignSystemModule} from "../../../design-system/design-system.module";
import {NgIf} from "@angular/common";
import {TitleContentLoaderComponent} from "../../../global/title-content-loader/title-content-loader.component";
import {RightSliderService} from "../../../../services/front/right-slider.service";

@Component({
  selector: 'app-agent-settings-wrapper',
  imports: [
    AgentsSettingsComponent,
    DesignSystemModule
  ],
  template: `
      <div class="agent-settings-wrapper">
          <div class="header-height">
              <!-- Title -->
              <div class="pl-l pr-l pt-l pb-l slider-header">
                  <div class="flex-center w-100">
                      <div class="settings-icon flex-center" style="flex-shrink: 0;">
                          <img width="24" src="assets/icons/settings-2.svg" class="filter-accent">
                      </div>
                      <span class="ml-s w-100" style="display: inline-block; line-height: 0.8rem">
                          <div class="flex-align-center mb-xs">
                          <div
                                  class="primary flex-column flex-justify-center flex-align-start gap-XS text-overflow-ellipsis"
                                  style="max-width: 500px;">
                            <label class="font-L fw-700">Paramètres</label>
                            <label class="font-M fw-500">Paramètres de l'agent poste de travail</label>
                          </div>
                        </div>
                      </span>
                  </div>

                  <div class="flex-align-center gap-S">
                      <app-icon-button type="stroked" background [img]="'assets/icons/close-drawer.svg'"
                                       (click)="close()">
                      </app-icon-button>
                  </div>
              </div>
          </div>
          <div class="pad-L">
              <div class="bg-rounded">
                  <app-agents-settings [displayTeams]="true" [fromDrawer]="true"></app-agents-settings>
              </div>

          </div>
      </div>
  `,
  styles: [`
    .settings-icon {
      width: 45px;
      height: 45px;
      border-radius: 11.25px;
      background: rgba(61, 192, 255, 0.1);
    }
  `]
})
export class AgentSettingsWrapperComponent {
  constructor(private rightSliderService: RightSliderService) {}

  close() {
    this.rightSliderService.close();
  }
}
